<copo-ecalloff-header [copyTo]="copyTo ?? ''" [customerCalloffReference]="custCallOffRef ?? ''"
	[nbOrderItems]="calledBatches?.length ?? 0" [rddMode]="rddMode ?? ''" [totalWeight]="getTonnage()">
	[pathHeaderText]="ecallData.id ? '' + ecallData.id : UNDERSCORE" (backButtonClick)="goBack()">
</copo-ecalloff-header>

<div class="card-title-block-non-sticky">
	<div class="card-title-label">
		<span [translateParams]="{objects: 'ecall-off.batches' | translate }"
			translate>ecall-off.ready-to-call</span><span>&#58;</span>
	</div>
</div>
<div *ngFor="let group of groupCalledBatch" class="ecall-alignment-margin card-info-block">
	<div class="grid-column-one-full">
		<div class="call-off-infoentry-form-row">
			<div class="card-row">
				<mat-icon class="row-icon certificate-info-label" svgIcon="at_consignment"></mat-icon>
				<span><ng-container *ngIf="calledBatches">
						<span>{{group.millDescription}}</span>
					</ng-container></span>
			</div>
			<div>
				<div class="card-content-label" translate>ecall-off-card-gross-quantity</div>
				<span class="center-alignment text-display-orange">
					<div class="copo-request-text">{{group.grossWeight !== undefined ?
						(group.grossWeight | copoNumber:'weight':'t') : UNDERSCORE}}</div>
				</span>
			</div>
			<div>
				<div class="card-content-label" translate>ecall-off-card-net-quantity</div>
				<div>
					<span class="center-alignment text-display-orange">
						<div class="copo-request-text">{{group.netWeight !== undefined ?
							(group.netWeight | copoNumber:'weight':'t') : UNDERSCORE}}</div>
					</span>
				</div>
			</div>
		</div>
	</div>
	<div *ngFor="let batch of group.millCodeGroup; let i = index;">
		<div class="grid-column-one-full copo-container ecall-background-color card-portal grid-6">
			<div class="card-row copo-bottom-margin">
				<span>
					<div class="batch-label" translate>commercial-documents.batch-number</div>
					<div class="card-content-value-cursor ecall-card-value-color">
							{{batch.batchReference ? batch.batchReference : UNDERSCORE}}
					</div>
				</span>
				<span>
					<div translate class="batch-label">ecall-off.ship-to</div>
					<div class="card-content-value">{{batch.originalShipToDescription ? batch.originalShipToDescription : UNDERSCORE}}</div>
				</span>
			</div>
			<div class="card-column copo-bottom-margin">
				<div>
					<span class="tag-tonnage" [title]="'batch-card.gross-weight' | translate">
						{{ batch.grossWeight | copoNumber:'weight':'t' }}
					</span>
				</div>
			</div>
			<div class="card-column">
				<div translate class="batch-label">ecall-off.unloading-reference</div>
				<div class="card-content-value">{{batch.unloadingReference ? batch.unloadingReference :
					UNDERSCORE}}</div>
			</div>
			<div class="card-row copo-bottom-margin">
				<span>
					<div class="batch-label" translate>commercial-documents.customer-order-number</div>
					<div class="card-content-value-cursor ecall-card-value-color">
						{{batch.customerOrderReference ? batch.customerOrderReference : UNDERSCORE}}
					</div>
				</span>
			</div>
			<div class="card-row copo-bottom-margin">
				<span>
					<div class="batch-label" translate>batch-card.customer-article-reference
					</div>
					<div class="card-content-value">
						{{batch.customerArticleReference ? batch.customerArticleReference : UNDERSCORE}}
					</div>
				</span>
			</div>
			<div class="card-column">
				<div translate class="batch-label">ecall-off.requested-ship-to</div>
				<div class="card-content-value">{{batch.shipToDescription ? batch.shipToDescription :
					batch.originalShipToDescription}}</div>
			</div>
			<div class="card-column" *ngIf="isReqDateVisible && !isFromToDateVisible && !batch.cancellationDate">
				<div translate class="batch-label">ecall-off.requested-date</div>
				<div class="card-content-value">{{(rddMode === 'EARLIEST' || rddMode === 'EXACT' ?
					batch.requestedDeliveryDateFrom : rddMode === 'LATEST' ? batch.requestedDeliveryDateTo : UNDERSCORE) | copoDate:'date'}}</div>
			</div>
			<div class="card-column" *ngIf="!isReqDateVisible && isFromToDateVisible && !batch.cancellationDate">
				<div translate class="batch-label">filter.number.from</div>
				<div class="card-content-value">{{(batch.requestedDeliveryDateFrom ? batch.requestedDeliveryDateFrom : UNDERSCORE) | copoDate:'date'}}</div>
				<div class="card-column" *ngIf="!isReqDateVisible && isFromToDateVisible && !batch.cancellationDate">
					<div translate class="batch-label">filter.date.to</div>
					<div class="card-content-value">{{(batch.requestedDeliveryDateTo ?
						batch.requestedDeliveryDateTo : UNDERSCORE) | copoDate:'date'}}</div>
				</div>
			</div>
			<div class="card-row comment-gap" *ngIf="canShowComments">
				<mat-icon svgIcon="comment"></mat-icon>
				<div class="card-content-value">{{batch.comment ? batch.comment : UNDERSCORE}}</div>
			</div>
		</div>
	</div>
	<br>
</div>